import { buttons } from './buttons';
import { space } from './spaces';
import { colors } from './colors';
import { fontSizes } from './fontSizes';
import { fonts } from './fonts';
import { iconSizes } from './iconSizes';
import { shadows } from './shadows';
import { radii } from './radius';
import { transitions } from './transitions';
import { mediaQueries, breakpoints } from './mediaQueries';
import { ITheme } from './ITheme';
// eslint-disable-next-line import/no-anonymous-default-export
export const theme: ITheme = {
  space,
  colors,
  fontSizes,
  fonts,
  buttons,
  iconSizes,
  shadows,
  breakpoints,
  radii,
  transitions,
  mediaQueries,
};

export * from './IButtons';
export * from './IColors';
export * from './IFonts';
export * from './IFontSizes';
export * from './ITheme';
export * from './ISpaces';
